import invalidatePlaybookBuilderQueries from '@/hooks/playbooks/helpers/invalidatePlaybookBuilderQueries';
import coerceToRecord from '../helpers/coerceToRecord';
import eventMatchesPlaybookLifecycleTool from '../helpers/eventMatchesPlaybookLifecycleTool';
import getStringValue from '../helpers/getStringValue';
import type {
    BuildRefetchPlaybookBuilderOnMutationSubscriptionParams,
    ChatEffectSubscription,
} from '../types';

const buildRefetchPlaybookBuilderOnMutationSubscription = ({
    id,
    routePattern,
}: BuildRefetchPlaybookBuilderOnMutationSubscriptionParams): ChatEffectSubscription => {
    return {
        id,
        routePattern,
        eventType: 'TOOL_CALL_RESULT',
        filter: ({ event, matchParams }) => {
            if (
                !eventMatchesPlaybookLifecycleTool({
                    event,
                })
            ) {
                return false;
            }

            const args = coerceToRecord({ value: event.args });
            const result = coerceToRecord({ value: event.result });
            const mutatedPlaybookId =
                getStringValue({ value: args.playbookId }) ||
                getStringValue({ value: result.playbookId });

            return !mutatedPlaybookId || mutatedPlaybookId === matchParams.playbookId;
        },
        action: ({ queryClient, matchParams }) => {
            invalidatePlaybookBuilderQueries({
                queryClient,
                playbookId: matchParams.playbookId,
            });
        },
    };
};

export default buildRefetchPlaybookBuilderOnMutationSubscription;
